import { useBlocker, useBeforeUnload } from "react-router-dom";
import { useFormDirtyContext } from "../../hooks/use-form-dirty-context";
import { UnsavedChangesModal } from "../unsaved-changes-modal";

export function NavigationBlocker() {
  const { isDirty } = useFormDirtyContext();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname,
  );

  useBeforeUnload(
    (event) => {
      if (isDirty) {
        event.preventDefault();
      }
    },
    { capture: true },
  );

  const handleContinueEditing = () => {
    blocker.reset?.();
  };

  const handleLeave = () => {
    blocker.proceed?.();
  };

  return (
    <UnsavedChangesModal
      isOpen={blocker.state === "blocked"}
      onContinueEditing={handleContinueEditing}
      onLeave={handleLeave}
    />
  );
}
